
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form16";
const form16State = namespace("Form16");

import Form16ProcessHeader from "@/components/process/Form16/components/Form16ProcessHeader.vue";
import Form16 from "@/components/process/Form16/components/pdf/Form16.vue"

import { form16StatusInfoType } from '@/types/Information/Form16';

@Component({
    components:{
        Form16ProcessHeader,
        Form16
    }
})
export default class PreviewForm16 extends Vue {

    @form16State.State
    public currentOfferToSettleCostsId: string;

    stepsCompleted = {} as form16StatusInfoType; 
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;         
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form16"}); 
    }
}
